var map = {
	"./menu-icon1-d.png": 6888,
	"./menu-icon2-d.png": 61771,
	"./menu-icon3-d.png": 27382,
	"./menu-icon4-d.png": 12761,
	"./menu-icon5-d.png": 76332,
	"./menu-icon6-d.png": 34383,
	"./menu-icon7-d.png": 16154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99608;